<template>
  <v-container>
    <div
      v-if="loading"
      :style="styleObject"
      class="text-center"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div
      v-else
    >
      <div
        id="idTable"
        style="overflow-x: auto;"
      >
        <table
          style="width: 100%; color: black; border-collapse: collapse;"
          class="elevation-1"
        >
          <thead>
            <tr>
              <th
                id="dadoMovimentacao"
                style="text-align: center;"
              />
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              >
                Estrutura Organizacional
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              >
                Quantidade (kg)
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              >
                Qtd. Mês Anterior (kg)
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              >
                Variação de Qtd. Mensal
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              >
                Qtd. Mês do Ano Anterior (kg)
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              >
                Variação de Qtd. Anual
              </th>
            </tr>
          </thead>
          <tbody
            v-for="(item, index) in evolucaoVendasSupervisorVolume"
            :key="item.id"
          >
            <!-- Linha principal -->
            <tr>
              <td style="text-align: center;">
                <button @click="toggleExpand(index)">
                  {{ expanded.includes(index) ? '▲' : '▼' }}
                </button>
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: left;"
              >
                {{ item.nome }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.quantidade }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.quantidade_mes_anterior }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                <v-chip
                  :color="getColor(item.variacao_mensal)"
                  dark
                >
                  {{ item.variacao_mensal }}
                </v-chip>
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.quantidade_ano_anterior }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                <v-chip
                  :color="getColor(item.variacao_anual)"
                  dark
                >
                  {{ item.variacao_anual }}
                </v-chip>
              </td>
            </tr>
            <!-- Linha expandida -->
            <tr
              v-if="expanded.includes(index)"
              :key="'expanded-' + item.id"
            >
              <td colspan="7">
                <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
                  <thead>
                    <tr>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Estrutura Organizacional
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Quantidade (kg)
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Qtd. Mês Anterior (kg)
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Variação de Qtd. Mensal
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Qtd. Mês do Ano Anterior (kg)
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Variação de Qtd. Anual
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(sub, idx) in item.evolucaoVendasVendedoresVolume"
                      :key="idx"
                    >
                      <td
                        id="dadoMovimentacao"
                        style="text-align: left;"
                      >
                        {{ sub.nome }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.quantidade }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.quantidade_mes_anterior }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        <v-chip
                          :color="getColor(sub.variacao_mensal)"
                          dark
                        >
                          {{ sub.variacao_mensal }}
                        </v-chip>
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.quantidade_ano_anterior }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        <v-chip
                          :color="getColor(sub.variacao_anual)"
                          dark
                        >
                          {{ sub.variacao_anual }}
                        </v-chip>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
  import Vendas from '../../../../../services/vendas'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowEvolucaoVolumeVendas',
    emits: [],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      supervisor: [],
      receita: [],
      expanded: [],
      headersEvolucaoVendasVolume: [
        { text: 'Estrutura Organizacional', value: 'nome', width: '300px', class: 'black--text title' },
        { text: 'Quantidade (kg)', value: 'quantidade', width: '180px', align: 'right', class: 'black--text title' },
        { text: 'Qtd. Mês Anterior (kg)', value: 'quantidade_mes_anterior', width: '180px', align: 'right', class: 'black--text title' },
        { text: 'Variação de Qtd. Mensal', value: 'variacao_mensal', width: '180px', align: 'right', class: 'black--text title' },
        { text: 'Qtd. Mês do Ano Anterior (kg)', value: 'quantidade_ano_anterior', width: '180px', align: 'right', class: 'black--text title' },
        { text: 'Variação de Qtd. Anual', value: 'variacao_anual', width: '180px', align: 'right', class: 'black--text title' },
      ],
      evolucaoVendasSupervisorVolume: [],
      enableEvolucaoVendasVolume: false,
    }),

    created () {
      eventEmit.$on('update-dados-clientes-vendas', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados-clientes-vendas', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, supervisor) {
        this.primeiroDia = primeiroDia
        this.date = dataFinal
        this.select = select
        this.supervisor = supervisor

        this.showDadosEvolucaoVendasVolume()
      },

      async showDadosEvolucaoVendasVolume () {
        this.enableEvolucaoVendasVolume = true
        this.loading = true

        this.evolucaoVendasSupervisorVolume = []
        this.expanded = []

        await Vendas.showEvolucaoVendasVolume(this.primeiroDia, this.date, this.select, this.supervisor, this.receita, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            const setPerson = new Set()

            const filterEvolucaoVendas = resposta.data.volumeSupervisores.filter((person) => {
              const duplicatedPerson = setPerson.has(person.nome)
              setPerson.add(person.nome)
              return !duplicatedPerson
            })

            this.evolucaoVendasSupervisorVolume = filterEvolucaoVendas.map((item) => {
              var listaVolumeSupervisores = ({
                cod_supervisor: item.cod_supervisor,
                nome: item.nome,
                quantidade: item.quantidade.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', ''),
                quantidade_mes_anterior: item.quantidade_mes_anterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', ''),
                variacao_mensal: item.variacao_mensal + '%',
                quantidade_ano_anterior: item.quantidade_ano_anterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', ''),
                variacao_anual: item.variacao_anual + '%',
                icone: item.icone,
                expandir: item.expandir,
                evolucaoVendasVendedoresVolume: this.orderVendedores(item.evolucaoVolumeVendedores),
              })

              return listaVolumeSupervisores
            })
          } else if (resposta.data.msg === 'Não há faturamento para o período selecionado') {
            this.evolucaoVendasSupervisorVolume = []
            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      orderVendedores (value) {
        const setPerson = new Set()

        const filterVendedores = value.filter((person) => {
          const duplicatedPerson = setPerson.has(person.nome)
          setPerson.add(person.nome)
          return !duplicatedPerson
        })

        const vendedores = filterVendedores.map((item) => {
          var listaVolumeVendedores = ({
            nome: item.nome ? item.nome : '-',
            quantidade: parseFloat(item.quantidade).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', ''),
            quantidade_mes_anterior: parseFloat(item.quantidade_mes_anterior).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', ''),
            variacao_mensal: item.variacao_mensal + '%',
            quantidade_ano_anterior: parseFloat(item.quantidade_ano_anterior).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', ''),
            variacao_anual: item.variacao_anual + '%',
          })

          return listaVolumeVendedores
        })

        return vendedores
      },

      toggleExpand (index) {
        const i = this.expanded.indexOf(index)
        if (i > -1) {
          this.expanded.splice(i, 1)
        } else {
          this.expanded.push(index)
        }
      },

      expandedVendedores (value) {
        if (value.icone === 'mdi-plus') {
          value.expandir = true
          value.icone = 'mdi-minus'
        } else {
          value.icone = 'mdi-plus'
          value.expandir = false
        }
      },

      getColor (value) {
        if (value < '0%') {
          return 'red'
        } else {
          return 'green'
        }
      },
    },
  }
</script>

<style scoped>
 @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }
</style>
